import Vue from 'vue'
import Vuetify from 'vuetify/lib'

Vue.use(Vuetify)

export default new Vuetify({
  theme: {
    themes: {
      light: {
        primary: '#009bde',
        secondary: '#002d40',
        accent: '#020204',
        'app-orange': '#fb6625'
      }
    }
  }
})
